import * as React from "react"
import {SelectSeeker} from "@ui-seeker/core";


const OPTIONS = [
	{ label: 'Only in stock', value: 'in_stock' },
	{ label: 'Out of stock', value: 'out_of_stock' }
]
export default function RepricingFormScopeStock({ value, ...props }) {

	if(Array.isArray(value))
		value = value.length ? value[0] : null

	if (value !== null)
		value = value ? 'in_stock' : 'out_of_stock'

    return <SelectSeeker
		options={OPTIONS}
		value={value}
		{...props}
	/>
}